(() => {
  const configNode = document.getElementById('ab-gift-config');
  const dialog = document.getElementById('ab-gift-dialog');
  if (!configNode || !dialog) return;
  const config = JSON.parse(configNode.textContent);
  const root = config.root.endsWith('/') ? config.root : `${config.root}/`;
  const hideIds = new Set(config.hideIds.map(Number));
  const status = dialog.querySelector('[data-ab-gift-status]');
  const catalog = dialog.querySelector('[data-ab-gift-catalog]');
  const giftValue = 'peaux-300';
  let currentCart;
  let syncPromise;
  let pending = false;
  let catalogLoaded = false;
  let prompted = false;
  let restoreDrawer = false;
  let returnFocus;
  let checkoutReady = false;

  const gifts = (cart) => cart.items.filter((item) => item.properties?._ab_gift === giftValue);
  const eligible = (cart) => cart.items.reduce((sum, item) => sum +
    (hideIds.has(Number(item.product_id)) ? item.original_line_price : 0), 0) >= config.threshold;

  async function request(path, data) {
    const response = await fetch(`${root}${path}`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json', ...(data ? { 'Content-Type': 'application/json' } : {}) },
      ...(data ? { method: 'POST', body: JSON.stringify(data) } : {}),
    });
    const result = await response.json();
    if (!response.ok || result.status || result.errors) {
      throw new Error(result.description || result.message || (typeof result.errors === 'string' && result.errors) || 'Le panier est momentanément indisponible. Réessayez.');
    }
    return result;
  }

  const sections = () => ({ sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname });
  function notify(cart) {
    currentCart = cart;
    if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ab-gift', cartData: cart });
    const iconHtml = cart.sections?.['cart-icon-bubble'];
    if (iconHtml) {
      const content = new DOMParser().parseFromString(iconHtml, 'text/html').querySelector('.shopify-section');
      if (content) document.getElementById('cart-icon-bubble').innerHTML = content.innerHTML;
    }
  }

  // Shopify enforces the price. This cleanup only keeps invalid or duplicate gift lines out of the customer's basket.
  async function reconcile() {
    let cart = await request('cart.js');
    const allowed = eligible(cart);
    const selected = gifts(cart);
    const updates = {};
    selected.forEach((item, index) => {
      const quantity = allowed && index === 0 ? 1 : 0;
      if (item.quantity !== quantity) updates[item.key] = quantity;
    });
    if (Object.keys(updates).length) {
      cart = await request('cart/update.js', { updates, ...sections() });
      notify(cart);
    }
    currentCart = cart;
    if (!allowed) prompted = false;
    return cart;
  }

  function sync() {
    if (!syncPromise) syncPromise = reconcile().finally(() => { syncPromise = null; });
    return syncPromise;
  }

  function updateChoices() {
    const selected = gifts(currentCart)[0];
    for (const button of catalog.querySelectorAll('[data-ab-gift-variant]')) {
      const id = Number(button.dataset.abGiftVariant);
      const purchased = currentCart.items.filter((item) => item.variant_id === id && item.properties?._ab_gift !== giftValue)
        .reduce((sum, item) => sum + item.quantity, 0);
      const unavailable = button.dataset.giftAvailable !== 'true' || purchased >= Number(button.dataset.giftMax);
      button.disabled = pending || unavailable;
      button.setAttribute('aria-pressed', String(selected?.variant_id === id));
      button.querySelector('[data-gift-choice-state]').textContent = unavailable ? 'Indisponible' : selected?.variant_id === id ? 'Votre choix' : 'Choisir';
    }
  }

  async function open(trigger) {
    if (pending || dialog.open) return;
    pending = true;
    try {
      await sync();
      if (!eligible(currentCart)) return;
      returnFocus = trigger || document.activeElement;
      const drawer = document.querySelector('cart-drawer');
      restoreDrawer = drawer?.classList.contains('active');
      if (restoreDrawer) drawer.close();
      dialog.showModal();
      prompted = true;
      status.textContent = catalogLoaded ? '' : 'Chargement des modèles…';
      if (!catalogLoaded) {
        const response = await fetch(`${root}?section_id=ab-gift-picker`, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Impossible de charger les modèles. Fermez puis réessayez.');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const grid = html.querySelector('.ab-gift-grid');
        if (!grid) throw new Error('Les modèles sont momentanément indisponibles.');
        catalog.replaceChildren(grid);
        catalogLoaded = true;
      }
      status.textContent = '';
    } catch (error) {
      status.textContent = error.message;
    } finally {
      pending = false;
      if (currentCart) updateChoices();
    }
  }

  async function select(button) {
    if (pending) return;
    pending = true;
    updateChoices();
    button.querySelector('[data-gift-choice-state]').textContent = 'Modification…';
    status.textContent = 'Modification de votre coussin…';
    let previous;
    let previousRemoved = false;
    let requestedId;
    try {
      if (!currentCart) await sync();
      if (!eligible(currentCart)) throw new Error('Le cadeau est disponible dès 350 € d’achat de peaux.');
      requestedId = Number(button.dataset.abGiftVariant);
      previous = gifts(currentCart)[0];
      if (previous?.variant_id === requestedId) { dialog.close(); return; }
      if (previous) {
        await request('cart/change.js', { id: previous.key, quantity: 0 });
        previousRemoved = true;
      }
      const result = await request('cart/add.js', { items: [{ id: requestedId, quantity: 1, properties: { _ab_gift: giftValue } }], ...sections() });
      const added = result.items?.find((item) => item.variant_id === requestedId && item.properties?._ab_gift === giftValue);
      let cart;
      if (added?.final_line_price !== 0 || added.quantity !== 1 || !result.sections?.['cart-drawer']) {
        cart = await request('cart/update.js', { updates: {}, ...sections() });
        const selected = gifts(cart);
        if (selected.length !== 1 || selected[0].variant_id !== requestedId || selected[0].quantity !== 1 || selected[0].final_line_price !== 0) {
          throw new Error('Le cadeau n’a pas pu être validé. Aucun coussin payant n’a été ajouté. Réessayez.');
        }
      }
      if (cart) notify(cart);
      else currentCart.items = [...currentCart.items.filter((item) => item.key !== previous?.key), added];
      status.textContent = 'Votre coussin offert a été ajouté.';
      dialog.close();
      const drawer = document.querySelector('cart-drawer');
      if (drawer && (cart || result).sections?.['cart-drawer']) drawer.renderContents(cart || result);
      if (!cart) sync().then(notify).catch(() => {});
    } catch (error) {
      status.textContent = error.message;
      try {
        const cart = await request('cart.js');
        const added = gifts(cart).find((item) => item.variant_id === requestedId);
        if (added) await request('cart/change.js', { id: added.key, quantity: 0 });
        if (previousRemoved) {
          await request('cart/add.js', { items: [{ id: previous.variant_id, quantity: 1, properties: previous.properties }] });
        }
        notify(await sync());
      } catch (_) { /* The next cart interaction retries reconciliation. */ }
    } finally {
      pending = false;
      if (currentCart) updateChoices();
    }
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ab-gift-open]');
    if (trigger) { event.preventDefault(); open(trigger); }
    if (event.target.closest('[data-ab-gift-close]') && !pending) dialog.close();
    const choice = event.target.closest('[data-ab-gift-variant]');
    if (choice) select(choice);
  });
  dialog.addEventListener('cancel', (event) => { if (pending) event.preventDefault(); });
  dialog.addEventListener('close', () => {
    if (restoreDrawer) document.querySelector('cart-drawer')?.open();
    else if (returnFocus?.isConnected) returnFocus.focus();
  });

  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
    if (event.source === 'ab-gift' || pending) return;
    try {
      await sync();
      if (eligible(currentCart) && !gifts(currentCart).length && !prompted && event.source === 'product-form') open();
    } catch (_) { /* The next cart interaction retries; checkout always validates below. */ }
  });
  document.addEventListener('submit', async (event) => {
    if (event.submitter?.name !== 'checkout' || checkoutReady || !gifts(currentCart || { items: [] }).length) return;
    event.preventDefault();
    const form = event.target;
    const button = event.submitter;
    button.disabled = true;
    try {
      await sync();
      checkoutReady = true;
      button.disabled = false;
      form.requestSubmit(button);
    } catch (_) {
      button.disabled = false;
      const errors = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
      if (errors) errors.textContent = 'Impossible de vérifier le panier. Réessayez dans un instant.';
    }
  }, true);
  window.addEventListener('pageshow', () => sync().catch(() => {}));
  window.addEventListener('focus', () => { if (!pending) sync().catch(() => {}); });
  sync().catch(() => {});
})();
